import React from 'react';

var Copy = function Copy() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    role: "img",
    "aria-label": "Copy Button",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1774 12.5967V14.5322C10.1774 15.0667 9.74415 15.4999 9.20968 15.4999H1.46774C0.933273 15.4999 0.5 15.0667 0.5 14.5322V6.79025C0.5 6.25578 0.933273 5.82251 1.46774 5.82251H3.40323",
    stroke: "#666666",
    "stroke-linecap": "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5319 0.5H6.79001C6.25554 0.5 5.82227 0.933273 5.82227 1.46774V9.20968C5.82227 9.74415 6.25554 10.1774 6.79001 10.1774H14.5319C15.0664 10.1774 15.4997 9.74415 15.4997 9.20968V1.46774C15.4997 0.933273 15.0664 0.5 14.5319 0.5Z",
    stroke: "#666666"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};
Copy.displayName = "Copy";

export { Copy as default };
